import CloseIcon from '@mui/icons-material/Close';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { Box } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import { MemoAutocompleteWithText } from 'components/common/simpleInputFields/autocompleteWithText';
import { FocusEventHandler, HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';

interface NameInputProps {
  classes: ClassNameMap;
  onChange: (event: any, value: string | null | undefined) => void;
  charCount: number;
  maxLength: number;
  labelId: string;
  value: string;
  errorMessage: string | false;
  onBlur: FocusEventHandler<HTMLDivElement>;
}

const NameInput = ({
  classes,
  onChange,
  charCount,
  maxLength,
  labelId,
  value,
  errorMessage,
  onBlur,
}: NameInputProps): JSX.Element => {
  const hasError = Boolean(errorMessage);
  const intl = useIntl();
  return (
    <Box>
      <MemoAutocompleteWithText
        autoFocus={true}
        labelId={labelId}
        handleBlur={onBlur}
        // variant='outlined'
        handleChange={onChange}
        // className={classes.input}
        defaultValue={value || ''}
        error={
          errorMessage ? { helperText: { id: errorMessage } } : undefined
        }
        dense={true}
        fieldName='event-title'
        reserveSpaceForHelperText={true}
        // helperText={
        //   hasError
        //     ? errorMessage
        //     : charCount && `${charCount}/${maxLength}`
        // }
        // inputProps={{ maxLength }}
        data-qa='event-dialog-title-input'
        multiline={true}
        placeholder={formatTranslation(intl, CommonTranslationKeys.untitled)}
      />
    </Box>
  );
};

const dialogTitleStyles = {
  closeIcon: { opacity: 0.54, cursor: 'pointer' },
};

type DialogTitleProps = {
  classes: ClassNameMap;
  label: string;
  onClose: () => void;
} & HTMLAttributes<HTMLDivElement>;

const DialogTitle = ({
  classes,
  label,
  onClose,
  ...rest
}: DialogTitleProps): JSX.Element => (
  <div className={classes.dialogHeader} {...rest}>
    <span className={classes.dialogTitle}>{label}</span>
    <CloseIcon
      onClick={onClose}
      style={dialogTitleStyles.closeIcon}
      data-qa='event-dialog-close-button'
    />
  </div>
);

export { DialogTitle, NameInput };
